import { Link, useLocation } from 'react-router-dom';
import { ChatTeardrop, MapTrifold, BookOpen, BookmarkSimple, User } from '@phosphor-icons/react';

export function TabBar() {
  const location = useLocation();
  const isChatPage = location.pathname.startsWith('/chat/');

  // Don't render TabBar on chat pages
  if (isChatPage) return null;

  const tabs = [
    { path: '/', label: 'Chat', icon: ChatTeardrop, matchPath: (path: string) => path === '/' || path.startsWith('/chat/') },
    { path: '/explore', label: 'Explore', icon: MapTrifold, matchPath: (path: string) => path.startsWith('/explore') },
    { path: '/bible', label: 'Read', icon: BookOpen, matchPath: (path: string) => path.startsWith('/bible') },
    { path: '/bookmarks', label: 'Bookmarks', icon: BookmarkSimple, matchPath: (path: string) => path.startsWith('/bookmarks') },
    { path: '/account', label: 'Account', icon: User, matchPath: (path: string) => path.startsWith('/account') }
  ];

  return (
    <div className="hidden">
      <div className="flex justify-around">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex flex-col items-center py-2 px-4 ${
              tab.matchPath(location.pathname) 
                ? 'text-[#361E06]' 
                : 'text-gray-500 hover:text-[#361E06]'
            }`}
          >
            <tab.icon className="w-6 h-6" weight="bold" />
            <span className="text-xs mt-1">{tab.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
} 